
import { defineComponent } from 'vue'
export default defineComponent({
  emits: ['click'],
  name: 'Tab',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    }
  },
  setup(props, { attrs, emit }) {
    function handleClick(tabName: String) {
      emit('click', tabName)
    }
    return {
      handleClick
    }
  }
})
